import { Play } from 'lucide-react'
import dashboardImg from '../assets/SideDashboardImg.svg'

export default function HowitWorks() {
  return (
    <div className='flex flex-col items-center justify-center w-full px-4 sm:px-6 lg:px-20'>
      <div className='relative bg-[#1C1E24] rounded-2xl overflow-hidden w-full'>
        {/* Background geometric shapes */}
        <div className='absolute inset-0 overflow-hidden'>
          <div className='absolute top-0 left-1/4 w-96 h-96 bg-[#242731] transform rotate-12 -translate-y-48'></div>
          <div className='absolute bottom-0 right-1/4 w-80 h-80 bg-[#242731] transform -rotate-12 translate-y-40'></div>
          <div className='absolute top-1/2 left-0 w-64 h-64 bg-[#242731] transform rotate-45 -translate-x-32 -translate-y-32'></div>
        </div>

        <div className='relative grid grid-cols-1 lg:grid-cols-2 items-center min-h-[600px]'>
          {/* Left Side - Dashboard Mockup */}
          <div className='order-2 lg:order-1 flex justify-center lg:justify-start'>
            <div className='w-full max-w-lg lg:max-w-none lg:w-[520px] lg:-ml-6'>
              <img
                src={dashboardImg}
                alt='BritFiler Dashboard Interface'
                className='w-full h-auto rounded-lg lg:rounded-l-none shadow-2xl'
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div className='order-1 lg:order-2 p-8 md:p-12 lg:p-16 text-center lg:text-left'>
            {/* Play Button */}
            <div className='flex justify-center lg:justify-start mb-6'>
              <div className='w-16 h-16 bg-gray-600 rounded-full flex items-center justify-center shadow-lg hover:bg-gray-500 transition-colors cursor-pointer'>
                <Play className='w-6 h-6 text-white ml-1' fill='white' />
              </div>
            </div>

            {/* Heading */}
            <h2 className='text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 text-balance'>
              How It Works
            </h2>

            {/* Description */}
            <p className='text-lg md:text-xl text-gray-300 leading-relaxed text-pretty max-w-lg mx-auto lg:mx-0'>
              Filing your taxes doesnt have to be complicated. Our platform
              breaks the process into simple, guided steps — from entering your
              details to submitting directly to HMRC and Companies House. Fast,
              accurate, and stress-free.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
